<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<status-head></status-head>
		<status-list></status-list>
    </v-content>
  </v-app>
</template>

<script>

	import StatusHead from './Header.vue';
	import StatusList from './List.vue';
	export default {
		data () {
			return {
		
			}		
		},
		components: {
			StatusHead,
			StatusList
		}
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>